import { apiSlice } from "./apiSlice";
import {
  SchoolTeachersProgress,
  SearchTeachersParams,
  TeacherProgressDetail,
  TeacherSummary,
} from "../../services/teacherProgress/teacherProgress.types";

export const teacherProgressApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchTeachers: builder.query<TeacherSummary[], SearchTeachersParams>({
      query: ({ q, limit }) => ({
        url: "/admin/teacher-progress/teachers",
        method: "GET",
        params: { q, ...(limit !== undefined && { limit }) },
      }),
    }),
    getTeacherProgress: builder.query<TeacherProgressDetail, number>({
      query: (teacherId) => ({
        url: `/admin/teacher-progress/teachers/${teacherId}`,
        method: "GET",
      }),
    }),
    getSchoolTeachersProgress: builder.query<SchoolTeachersProgress, number>({
      query: (schoolId) => ({
        url: `/admin/teacher-progress/schools/${schoolId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazySearchTeachersQuery,
  useGetTeacherProgressQuery,
  useGetSchoolTeachersProgressQuery,
} = teacherProgressApi;
